export const selectHireReportsFilters = (state) => state?.hireReports?.filters;
export const selectHireReportsFilterWithValues = (state) =>
  state?.hireReports?.filterWithvalues;

export const selectHireReportsTimeFrame = (state) => state?.hireReports?.time;
export const selectHireReportsGroup = (state) => state?.hireReports?.group;

export const selectHireReportsCard = (state) => state?.hireReports?.cards;
export const selectHireReportsCardLoading = (state) =>
  state?.hireReports?.isCardLoading;

export const selectHireByDepartment = (state) =>
  state?.hireReports?.hiresByDepartment;
export const selectHireByDepartmentLoading = (state) =>
  state?.hireReports?.isHiresByDepartmentLoading;

export const selectHireBySource = (state) => state?.hireReports?.hiresBySource;
export const selectHireBySourceLoading = (state) =>
  state?.hireReports?.isHiresBySourceLoading;

export const selectHireChart = (state) => state?.hireReports?.chart;
export const selectHireTable = (state) => state?.hireReports?.table;
export const selectHireChartLoading = (state) =>
  state?.hireReports?.isChartLoading;
export const selectHireTableLoading = (state) =>
  state?.hireReports?.isTableLoading;
